import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import { useSelector } from "react-redux";

export default function DetailQuota() {
	const state = useSelector((store) => store.quotaCopy);
	const { detailQuotaTable } = state;
	const { rows, columns } = detailQuotaTable;
	return (
		<Box sx={{ mt: 3 }}>
			<Typography
				variant="subtitle1"
				sx={{ color: "blue.main" }}
				gutterBottom
			>
				Details of Quota
			</Typography>
			<DataGrid 
				rows={rows} 
				columns={columns} 
				disableColumnMenu
				/>
		</Box>
	);
}
